<div class="header-info" *ngIf="locationAvailable && weather">
    <span class="header-info-item"><mat-icon>place</mat-icon>{{ weather.city }}, {{ weather.country }}</span>
    <span class="header-info-item"><mat-icon>schedule</mat-icon>{{ currentTime }}</span>
    <span class="header-info-item"><mat-icon>device_thermostat</mat-icon>{{ weather.temperatureCelsius }}°C</span>
</div>
